import _first from 'lodash/first';
import _isEmpty from 'lodash/isEmpty';
import _flatten from 'lodash/flatten';

export default (set, get, zones) => {
  return set(
    () => ({
      dropZones: [...get().dropZones, ...zones]
    }),
    false,
    { type: 'ADD' }
  );
};
